import { useEffect, useState } from "react";
import api from "@/lib/api";

// Known phone/email and still-applicable permissions for this session's own household (editable prefill).
export const useContactPrefill = (open, url, setForm) => {
  const [known, setKnown] = useState(null);
  useEffect(() => {
    if (!open || !url) return;
    let alive = true;
    api.get(url).then((r) => {
      if (!alive) return;
      const d = r.data || {};
      setKnown(d);
      const fmt = (p) => { const x = (p || "").replace(/\D/g, "").slice(-10); return x.length === 10 ? `(${x.slice(0, 3)}) ${x.slice(3, 6)}-${x.slice(6)}` : (p || ""); };
      setForm((f) => ({ ...f, phone: f.phone || fmt(d.phone), email: f.email || d.email || "",
        shareTranscript: f.shareTranscript || !!d.transcript_share_on_file }));
    }).catch(() => setKnown(null));
    return () => { alive = false; };
  }, [open, url, setForm]);
  return known;
};

export const ConsentOnFile = ({ testid }) => (
  <p className="flex items-start gap-2 rounded-lg bg-[#EEF5EF] p-3 text-sm text-[#1F5132]" data-testid={testid}>
    You've already said a licensed insurance agent may contact you about your Medicare options, so you don't need to agree again.
  </p>
);
